import { Component, OnInit, Input, Output, EventEmitter, Renderer2, ElementRef } from '@angular/core';
import { encapsulation } from '../../encapsulation';
import { UBXSnack, UBXColor } from '../../../models';

@Component({
    selector: 'ubx-snackbar-snack',
    templateUrl: './snackbar-snack.component.html',
    host: { class: 'ubx-snackbar-snack flx f-ai:c f-jc:sb pd:x15 pd:y10 clr:wht pe:a' },
    encapsulation,
})
export class UBXSnackbarSnackComponent implements OnInit {
    @Input() snack: UBXSnack;
    @Output() remove: EventEmitter<void> = new EventEmitter();

    constructor(
        private render: Renderer2,
        public el: ElementRef,
    ) { }

    ngOnInit() {
        this.setType('bg', this.snack.type);
    }

    private setType(type: string, color: UBXColor) {
        this.appendClass(`${type}:${color}`);
    }

    close() {
        this.remove.emit();
    }

    private appendClass(name: string) {
        this.render.addClass(this.el.nativeElement, name);
    }
}
